function round(value: number, decimals: number) {
  const factor = 10 ** decimals;
  return Math.round(value * factor) / factor;
}

export const EMAIL_MAX_WIDTH_PX = 600;
export const EMAIL_MOBILE_BREAKPOINT_WIDTH_PX = 450;
export const EMAIL_BUILDER_MOBILE_WIDTH_PX = 375;
export const EMAIL_IMAGE_MAX_WIDTH_PX = EMAIL_MAX_WIDTH_PX * 2; // x2 for retina displays
export const EMAIL_IMAGE_MAX_KB = 1024 * 10; // 10 MB

/**
 * Convert a width in pixels to a percentage of the desktop width.
 * Makes padding responsive, e.g., so images don't get squashed on mobile.
 *
 * @param pixels The width in pixels.
 * @param baseWidth **FOR TESTING ONLY** - The base width to calculate percentage from.
 *                  Defaults to EMAIL_MAX_WIDTH_PX (600).
 *                  **WARNING**: Only pass a custom baseWidth in test code. Production emails
 *                  must always use the default 600px for proper responsive behavior.
 * @returns The width as a percentage of the base width.
 * @example
 * ```ts
 * // Production usage - always use default
 * widthPixelsToPercentage(300).rawNumber; // 50
 *
 * // Test usage only - for matching test viewport widths
 * widthPixelsToPercentage(20, 375).rawNumber; // 5.3333
 * ```
 */
export function widthPixelsToPercentage(
  pixels: number,
  baseWidth: number = EMAIL_MAX_WIDTH_PX,
): { rawNumber: number; formatted: `${number}%` } {
  const percentage = (pixels / baseWidth) * 100;
  return { rawNumber: percentage, formatted: `${round(percentage, 4)}%` };
}
